import { BiErrorCodes } from "../../viewer/common/bi-error/BiErrorCodes.ts";
import type { TabularGridState } from "../../viewer/tabular/hooks/gridState.types.ts";
import type { PivotGridState } from "../../viewer/pivot/hooks/gridState.types.ts";
import type { PreviewChartStateType } from "../../builder/chart/hooks/useChartStateBuilder.ts";
import type { ConfigurationValidReturnType } from "../../../utilities/isConfigurationValid.ts";
import { InvalidConfigurationReason } from "../../../utilities/isConfigurationValid.ts";

const calculating = "Data is being calculated...";
const tooLarge = "The report output is too large to be shown";

export const getTabularExportWarning = (state: TabularGridState): string | undefined => {
  if (state.loading) {
    return calculating;
  }
  if (state.error?.includes(BiErrorCodes.REPORT_SIZE_EXCEEDED)) {
    return tooLarge;
  }
  if (!state.configurationValidity.valid) {
    return "The Tabular grid is not correctly configured. Please ensure that you have added at least one dimension to the fields list";
  }
  if (state.rows.length === 0) {
    return "No data to export";
  }
  return undefined;
};

export const getPivotExportWarning = (state: PivotGridState, rowCount: number): string | undefined => {
  if (state.calculating) {
    return calculating;
  }
  if (state.error?.includes(BiErrorCodes.REPORT_SIZE_EXCEEDED)) {
    return tooLarge;
  }
  if (rowCount === 0) {
    return "The Pivot grid is not correctly configured. Please ensure that you have added at least one dimension to the Rows or Columns list";
  }
  return undefined;
};

export const getListExportWarning = (
  loading: boolean,
  totalRows: number | undefined,
  validity?: ConfigurationValidReturnType
): string | undefined => {
  if (validity?.valid === false) {
    return validity.reason === InvalidConfigurationReason.MandatoryFieldIsNotSelected
      ? "Set all mandatory parameters to export the report."
      : "The List report is not correctly configured. Please ensure that you have added at least one dimension to the fields list";
  }
  if (loading) {
    return calculating;
  }
  if (totalRows === 0) {
    return "No data to export";
  }
  return undefined;
};

export const getChartExportWarning = (state: PreviewChartStateType): string | undefined => {
  if (state.calculating) {
    return calculating;
  }
  if (state.error?.includes(BiErrorCodes.REPORT_SIZE_EXCEEDED)) {
    return tooLarge;
  }
  if (!state.fieldsConfigured) {
    return "The Chart is not correctly configured. Please ensure that you have added Argument and Values lists";
  }
  return undefined;
};
